<template>
<div>
    <div class="pic">
      <p v-html="productItem.Content">  </p>
   </div>

      <!-- <div class="productDown">
        <h6 class="productDownTitle">版本下载</h6>
        <div class="productDownItem" v-for="item in productDown" :key="item.ID">
          <p><span>{{item.Edition}}</span> <a :href='item.Path'>下载</a></p>
          <p>{{item.Info}}</p>
        </div>
    </div> -->
</div>

</template>

<script>
import { getProductShow } from '@/api/product'
// 引入根路径
import request from '@/utils/request'
export default {
  data () {
    return {
      productItem: {},
      productDown: {} // 下载
    }
  },
  watch: {
    '$route' () {
      this.getProductShow({ id: this.$route.params.id })
      // this.getProductDown({ id: this.$route.params.id })
    }
  },
  created () {
    // console.log(this.$route.params.id, 'this.$route.params.idthis.$route.params.id')
    this.getProductShow({ id: this.$route.params.id })
    // this.getProductDown({ id: this.$route.params.id })
  },
  methods: {

    async getProductShow (data) {
      const res = await getProductShow(data)
      const base = request.defaults.baseURL
      const oldBase = '/Upload/Image/'
      if (res.Msg === '获取成功') {
        this.productItem = res.Data
        if (this.productItem.Content !== null) {
          this.productItem.Content = this.productItem.Content.replace(/\/Upload\/Image\//g, base + oldBase)
        }
        // this.productDown.forEach(item => {
        //   item.Path = request.defaults.baseURL + item.Path
        // })
      }
      // console.log(res, '下载')
    }
  }

}
</script>

<style lang="scss" scoped>
$md:72/192*2;
.pic{
  min-height: 510px/$md;
  p{
    width: 100%;
    img{
      width: 100%;
    }
  }
}
// 产品下在
.productDown{
  width: 750px/$md;
  margin: 0 auto;
  font-size: 20px/$md;
  min-height: 625px/$md;
  .productDownTitle{
    font-size: 20px/$md;
    border: 1px/$md solid rgb(199, 200, 199);
    padding-top: 10px/$md;
    padding-bottom: 10px/$md;
  }
  .productDownItem{
    margin-top:20px/$md;
    margin-bottom:20px/$md;
  }
}
</style>
